import React from "react";
import PolicyLayout from "./PolicyLayout";

function ProductInformation() {
  return (
    <PolicyLayout
      title="Product description, colour and material variation policy"
      intro="Product pages combine photographs with the specific name, use, material, dimensions, colour, care and safety information for that item."
    >
      <section>
        <h2>Measurements and intended use</h2>
        <p>Dimensions, weight or volume marked as approximate allow for normal measuring and production variation. A product should be chosen by the listed use rather than appearance alone: decorative vases are not cooking vessels, accent lamps are not primary task lighting, and candle accessories require heat separation.</p>
      </section>

      <section>
        <h2>Colour and screen display</h2>
        <p>Screen calibration, brightness and room light affect perceived colour. The written colour description and gallery together provide the buying reference. A materially different colour or product is assessed as incorrect supply; a minor display shift that remains within the stated colour family is not by itself a defect.</p>
      </section>

      <section>
        <h2>Material-specific variation</h2>
        <ul>
          <li>Porcelain and stoneware may differ in glaze pooling, speckles, brush edges and hand-finished line width.</li>
          <li>Glass can show small bubbles or optical distortion that does not affect safe use; cracks, sharp chips and unstable bases are not normal variation.</li>
          <li>Wood ribs and frames vary in grain and tone. Cotton weave, embroidery alignment and paper fibre also differ between pieces.</li>
          <li>Metallic-effect decoration and printed surfaces may reflect surrounding light differently from a photograph.</li>
        </ul>
      </section>

      <section>
        <h2>Food, drink and alcohol information</h2>
        <p>The label delivered on confectionery, tea, sparkling drinks and spirits is the final source for ingredients, allergens, nutrition, net contents, dates, storage, alcohol strength and producer information. Do not consume the item if that label conflicts materially with the order, the seal is compromised, or the packaging is damaged. Photograph the issue and begin a product-problem request.</p>
      </section>

      <section>
        <h2>Reporting a material mismatch</h2>
        <p>Keep the product, label and packaging together and send the order number, the listing detail at issue, and photographs taken in neutral light. The review distinguishes disclosed variation from wrong size, wrong material, missing components, damage or false description. Mandatory remedies remain available where a product does not conform to protected requirements.</p>
      </section>
    </PolicyLayout>
  );
}

export default ProductInformation;
